<template>
  <layout-no-menu>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Payment Request</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <template v-if="invoice">
        <ion-item lines="none">
          <ion-label text-wrap>
            <p>{{ invoice.tournamentName }}</p>
            <h1>{{ money(invoice.amountCents) }}</h1>
            <p>{{ invoice.description }}</p>
          </ion-label>
        </ion-item>
        <ion-list v-if="invoice.items && invoice.items.length">
          <ion-item v-for="i in invoice.items" :key="i.playerId">
            <ion-label>{{ i.description }}</ion-label>
            <ion-note slot="end">{{ money(i.amountCents) }}</ion-note>
          </ion-item>
        </ion-list>

        <template v-if="invoice.status === 'Pending'">
          <ion-item v-if="cancelled" lines="none"><ion-label text-wrap color="warning"><p>Checkout was cancelled. No charge was made.</p></ion-label></ion-item>
          <ion-item>
            <ion-label position="stacked">Email for your receipt (optional)</ion-label>
            <ion-input type="email" inputmode="email" :value="email" @input="email = $event.target.value"></ion-input>
          </ion-item>
          <p style="color:red" v-if="error">{{ error }}</p>
          <div class="ion-padding-horizontal ion-margin-top">
            <ion-button expand="block" :disabled="busy" @click="pay">{{ busy ? 'Opening checkout…' : 'Pay ' + money(invoice.amountCents) }}</ion-button>
            <p class="ion-text-center" style="font-size:12px;color:gray">Secure checkout by {{ invoice.provider }}</p>
          </div>
        </template>
        <ion-item v-else lines="none">
          <ion-label text-wrap>
            <h2 v-if="invoice.status === 'Paid'">Paid. Thank you!</h2>
            <h2 v-else>This payment request is {{ invoice.status.toLowerCase() }}.</h2>
          </ion-label>
        </ion-item>
      </template>
      <ion-item v-else-if="error" lines="none"><ion-label text-wrap color="danger"><p>{{ error }}</p></ion-label></ion-item>
      <ion-item v-else lines="none"><ion-label>Loading…</ion-label></ion-item>
    </ion-content>
  </layout-no-menu>
</template>

<script>
import PaymentAPI from "@/services/PaymentAPI";
import Authentication from "@/services/Authentication";
const paymentAPI = new PaymentAPI();
const authentication = new Authentication();

export default {
  name: "Invoice",
  data() {
    const user = authentication.getUser();
    return {
      tournamentId: this.$route.params.tournament,
      orderId: parseInt(this.$route.params.id),
      key: this.$route.query.key || "",
      cancelled: this.$route.query.cancelled === "1",
      invoice: null,
      email: user && user.email ? user.email : "",
      busy: false,
      error: "",
    };
  },
  methods: {
    money(cents) { return PaymentAPI.money(cents); },
    async pay() {
      this.busy = true;
      this.error = "";
      try {
        const r = await paymentAPI.payInvoice(this.orderId, this.key, this.email);
        if (r && r.checkoutUrl) { window.location.href = r.checkoutUrl; return; }
        this.error = "Could not start checkout.";
      } catch (e) {
        this.error = typeof e === "string" ? e : "Could not start checkout.";
      } finally {
        this.busy = false;
      }
    },
  },
  async created() {
    try {
      this.invoice = await paymentAPI.invoice(this.orderId, this.key);
    } catch (e) {
      this.error = typeof e === "string" ? e : "This payment link is not valid or has expired.";
    }
  },
};
</script>
